import React from 'react';

import {AnalysisSearchAttributesGraphQL} from '../../../../graphql-fragments/analysis-tool/__generated/AnalysisSearchAttributesGraphQL';
import BaseAnalyticsSidepanelItem, {BaseAnalyticsSidepanelItemProps} from './BaseAnalyticsSidepanelItem';

export type AnalysisSidepanelItemProps = {
  analysis: AnalysisSearchAttributesGraphQL;
} & Pick<
  BaseAnalyticsSidepanelItemProps<AnalysisSearchAttributesGraphQL>,
  'active' | 'isCompact' | 'openResult' | 'isChild'
>;

export default function AnalysisSidepanelItem(props: AnalysisSidepanelItemProps): JSX.Element {
  return (
    <BaseAnalyticsSidepanelItem
      {...props}
      item={props.analysis}
      // TODO(BNCH-48696): Track open event for Analyses
    />
  );
}
